import { delimiters } from './constants';

const searchParams = new URLSearchParams(location.search);
const engagementId = (searchParams.get('engagementId') || searchParams.get('engagementid')) ?? undefined;

export function titleCase(str) {
  const delimiterRegex = new RegExp(`(^|[${delimiters.join('\\')}])(\\w)`, 'g');
  return str?.replace("'", "").replace(delimiterRegex, 
	(_, delimiter, char) => 
	  delimiter + char.toUpperCase());
};

export function clickActionArgs(name, controlType, locationInPage, URL) {
	let baseArgs = {
		web: {
			webInteraction: {
				name: titleCase(name),
				type: 'other'
			},
			_etassureco: {
				controlType
			}
		},
		siteKnowledge: {
			supportSiteSearch: {
				locationInPage
			}
		}
	};

	if (URL) {
		baseArgs.web.webInteraction.URL = URL;
	}

	return baseArgs;
};

export function pageViewArgs(name, siteSection, isHomePage = false, isErrorPage = false) {
	let baseArgs = {
		web: {
			webPageDetails: {
				name: titleCase(name),
				siteSection: titleCase(siteSection),
				isHomePage,
				isErrorPage
			}
		}
	};

	if (engagementId) {
		if (!baseArgs.web._etassureco) {
			baseArgs.web._etassureco = {engagementNumber: engagementId};
		}
	}
	
	return baseArgs;
};
